import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { StaticRouter } from 'react-router-dom/server'; // Import StaticRouter for SSR
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import Home from './Components/Home/Home';
import Blog from './Components/Blog/Blog';
import BlogDetail from './Components/Blog/BlogDetail';
import About from './Components/About/About';
import Ingredents from './Components/Ingredents/Ingredents';
import CardDetails from './Components/About/CardDetails';
import Consultation from './Components/Contact/Consultation';
import Shop from './Components/Shop/Shop';
import Chatbox from './Components/Chatbox/Chatbox';
import "aos/dist/aos.css";
import AOS from "aos";
import ShopDetails from './Components/Shop/Shopdetails';
import Disclaimer from './Components/Disclaimer/Disclaimer';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, [pathname]);

  return null;
}

function App({ location }) {
  useEffect(() => {
    // Only run AOS animations and disable context menu on the client side
    if (typeof window !== 'undefined') {
      AOS.init({
        duration: 1000,
      });
      AOS.refresh();

      // Disable right-click context menu and certain keyboard shortcuts
      const handleKeyDown = (event) => {
        if (
          event.keyCode === 123 || // F12
          (event.ctrlKey && event.shiftKey && ['I', 'J'].includes(event.key)) || // Ctrl+Shift+I/J
          (event.ctrlKey && event.key === 'U') // Ctrl+U
        ) {
          event.preventDefault();
        }
      };

      const handleContextMenu = (event) => {
        event.preventDefault();
      };

      // Add event listeners
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('contextmenu', handleContextMenu);

      // Cleanup event listeners on component unmount
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
        document.removeEventListener('contextmenu', handleContextMenu);
        AOS.refresh();
      };
    }
  }, []);

  // Use StaticRouter on the server and BrowserRouter on the client
  const RouterComponent = typeof window !== 'undefined' ? Router : StaticRouter;

  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/shopdetails/:id" element={<ShopDetails />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/about" element={<About />} />
        <Route path="/ingredients/:id" element={<CardDetails />} />
        <Route path="/ingredients" element={<Ingredents />} />
        <Route path="/consultation" element={<Consultation />} />
        <Route path="/shop" element={<Shop />} />
      </Routes>
      <Footer />
      <Chatbox />
      </>
    
  );
}

export default App;
